import PropTypes from 'prop-types';

import SingleUpdateHistoryBlock from '../SingleUpdateHistoryBlock/SingleUpdateHistoryBlock';

const HistoryList = ({histories}) => {
  return (
    <>
      {histories.map(h => (
        <SingleUpdateHistoryBlock key={h.startTime} history={h} />
      ))}
    </>
  );
};

HistoryList.propTypes = {
  histories: PropTypes.array.isRequired
};

export default HistoryList;
